<span
  class="{{ customClass }}"
  [ngStyle]="styleConfig"
  [innerHTML]="text"
  [attr.role]="role"
  [attr.aria-label]="ariaLabel"
  [attr.aria-live]="ariaLive"
  [attr.aria-hidden]="ariaHidden"
  [attr.aria-describedby]="ariaDescribedby"
  [attr.aria-labelledby]="ariaLabelledby"
></span>
